export enum Redirect {
  AA = 'AAD',
  PO = 'PO',
  POD = 'POD'
}
